import { create } from 'zustand';

import { getUserCountry } from '@/utils/getUserCountry';

export interface UserGeoType {
  country: string;
  currency: string;
}

const useUserGeoStore = create<{
  geo: UserGeoType | null;
  setGeo: (geo: UserGeoType | null) => void;
}>((set) => ({
  geo: null,
  setGeo: (geo) => set({ geo }),
}));

export const useUserGeo = () => {
  const geo = useUserGeoStore((state) => state.geo);
  const setGeo = useUserGeoStore((state) => state.setGeo);

  const initGeo = async () => {
    if (process.env.NODE_ENV === 'production') {
      try {
        const country = await getUserCountry();
        console.log('Country:', country);
        setGeo({
          country,
          currency: 'usd',
        });
      } catch (e) {
        console.error('Error fetching geo data', e);
        setGeo({
          country: 'US',
          currency: 'usd',
        });
      }
    } else {
      setGeo({
        country: 'US',
        currency: 'usd',
      });
    }
  };

  return { geo, setGeo, initGeo };
};
